<ng-content select="panel-heading"></ng-content>
<ng-content select="panel-body"></ng-content>
